import { render } from "./Shop.vue?vue&type=template&id=90972bec&scoped=true&bindings={\"product\":\"data\",\"products\":\"options\",\"subscriptions\":\"options\",\"activeWorkspace\":\"options\",\"isWorkspaceAdmin\":\"options\"}"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=90972bec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-90972bec"

export default script